/* global axios */
import ApiClient from './ApiClient';

class NotificationDeliveriesAPI extends ApiClient {
  constructor() {
    super('notification_deliveries', { accountScoped: true });
  }

  list({ page = 1, per = 50, status, scenarioId } = {}) {
    return axios.get(this.url, {
      params: { page, per, status, scenario_id: scenarioId },
    });
  }
}

export default new NotificationDeliveriesAPI();
